export type GetBalanceResponseTypes = {
  balance: number;
  ledgerBalance: number;
  creditLimit: number;
  cashout?: {
    enabled: boolean;
    notice: string;
    dailyLimit?: number;
    cashoutableAmount: number;
  };
};
export const GetBalanceMutationKey = "Get-Balance";
